import { createSlice } from "@reduxjs/toolkit";
import {
  toGetBrands,
  toGetModel,
  toGetMyVehicle,
  togetCategories,
  ToEditCar,
  toAddVehicle,
  toGetProductCategories,
  toGetProductCategoriesTree,
  toGetServiceCategoriesTree,
} from "../actions/vehicle.actions";
import { normalizeProductCategories } from "../../utils/productCategories";

const initialState = {
  models: {
    list: [],
    status: "idle",
  } as any,
  brands: {
    list: [],
    status: "idle",
  } as any,
  categories: {
    list: [],
    status: "idle",
  } as any,
  productCategories: {
    list: [],
    status: "idle",
  } as any,
  serviceCategoryTree: {
    list: [],
    status: "idle",
  } as any,
  productCategoryTree: {
    list: [],
    status: "idle",
  } as any,
  myVehicles: {
    list: [],
    status: "idle",
  } as any,
  loading: false,
  error: null as unknown | null,
  EditCar: {
    loading: false,
  } as any,
  addVehivcule: {
    loading: false,
  } as any,
};
export const vehicleSlice = createSlice({
  name: "vehicles",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetModel.pending, (state) => {
      state.models = {
        list: state.models?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetModel.fulfilled, (state, action) => {
      state.models = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetModel.rejected, (state, action) => {
      state.models = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetBrands.pending, (state) => {
      state.brands = { list: [], status: "idle" };
    });
    builder.addCase(toGetBrands.fulfilled, (state, action) => {
      state.brands = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetBrands.rejected, (state, action) => {
      state.brands = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    builder.addCase(togetCategories.pending, (state) => {
      state.categories = { list: [], status: "idle" };
    });
    builder.addCase(togetCategories.fulfilled, (state, action) => {
      state.categories = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(togetCategories.rejected, (state, action) => {
      state.categories = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetProductCategories.pending, (state) => {
      state.productCategories.status = "loading";
    });
    builder.addCase(toGetProductCategories.fulfilled, (state, action) => {
      state.productCategories = {
        list: normalizeProductCategories(action.payload.data),
        status: "succedded",
      };
    });
    builder.addCase(toGetProductCategories.rejected, (state, action) => {
      state.productCategories = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetServiceCategoriesTree.pending, (state) => {
      state.serviceCategoryTree = {
        list: state.serviceCategoryTree?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetServiceCategoriesTree.fulfilled, (state, action) => {
      const payload = action.payload.data;
      const resolvedList = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.result)
            ? payload.result
            : payload && typeof payload === "object" && payload.id
              ? [payload]
              : [];
      state.serviceCategoryTree = {
        list: resolvedList,
        status: "succedded",
      };
    });
    builder.addCase(toGetServiceCategoriesTree.rejected, (state, action) => {
      state.serviceCategoryTree = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetProductCategoriesTree.pending, (state) => {
      state.productCategoryTree = {
        list: state.productCategoryTree?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetProductCategoriesTree.fulfilled, (state, action) => {
      const payload = action.payload.data;
      const resolvedList = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.result)
            ? payload.result
            : payload && typeof payload === "object" && payload.id
              ? [payload]
              : [];
      state.productCategoryTree = {
        list: resolvedList,
        status: "succedded",
      };
    });
    builder.addCase(toGetProductCategoriesTree.rejected, (state, action) => {
      state.productCategoryTree = { list: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetMyVehicle.pending, (state) => {
      state.myVehicles = {
        list: state.myVehicles?.list ?? [],
        status: "loading",
      };
    });
    builder.addCase(toGetMyVehicle.fulfilled, (state, action) => {
      state.myVehicles = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetMyVehicle.rejected, (state, action) => {
      state.myVehicles = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to edit Car
    builder.addCase(ToEditCar.pending, (state) => {
      state.EditCar.loading = true;
    });
    builder.addCase(ToEditCar.fulfilled, (state, action) => {
      state.EditCar = action.payload;
      state.EditCar.loading = false;
    });
    builder.addCase(ToEditCar.rejected, (state, action) => {
      state.EditCar = {};
      state.EditCar.loading = false;
      state.error = action.payload;
    });
    // to add Car
    builder.addCase(toAddVehicle.pending, (state) => {
      state.addVehivcule.loading = true;
    });
    builder.addCase(toAddVehicle.fulfilled, (state, action) => {
      state.addVehivcule = action.payload;
      state.EditCar.loading = false;
    });
    builder.addCase(toAddVehicle.rejected, (state, action) => {
      state.addVehivcule = {};
      state.addVehivcule.loading = false;
      state.error = action.payload;
    });
  },
});

export default vehicleSlice.reducer;
